// extracted by mini-css-extract-plugin
export default {"actions":"action-button_actions__JchHu","btn":"action-button_btn__dgULW","small":"action-button_small__KYHwE"};